var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('check-authorization',{attrs:{"requiresAuthorizations":['indice estados']}},[_c('estados-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }